import { INFO_INCOMPLETE_ERROR_TEXT } from "../../helpers/error.helper";

export class StepOneData {
  chiffreAffaire;
  isIndiv;
  readFDDC;
  readNotice;
  readSubConditions;
}

export function postValidateStepOneData(data) {
  const ca = parseInt(data.chiffreAffaire);
  if (Boolean(data.isIndiv)) {
    if (ca > 72600) {
      return {
        showContact: false,
        text: "Votre chiffre d'affaires doit être inférieur à 72 600 €."
      };
    }
    return null;
  } else {
    if (ca > 500000) {
      return {
        showContact: true,
        text: "Votre chiffre d'affaires est supérieur à 500 000 € HT, le contrat n'est pas possible."
      };
    } else {
      return null;
    }
  }
}

export function validateStepOneData(data) {
  if (
    !data.chiffreAffaire ||
    !data.readFDDC ||
    data.readFDDC !== "on" ||
    !data.readNotice ||
    data.readNotice !== "on" ||
    !data.readSubConditions ||
    data.readSubConditions !== "on"

  ) {
    return INFO_INCOMPLETE_ERROR_TEXT;
  }
  return null;
}

export function getFormValues(event) {
  const formData = new FormData(event.target);

  const data = {};
  for (let field of formData) {
    const [key, value] = field;
    data[key] = value;
  }
  return data;
}